import React, { useCallback } from "react";
import { useRoute, RouteProp, useNavigation, NavigationProp } from "@react-navigation/native";
import { RootStackParamList } from "../navigation/AppNavigator.web";
import ChatWindowContainer from "../containers/companion/ChatWindowContainer";
import { useGetCompanionChatByIdQuery } from "../graphql/generated/graphql";
import CompanionLayout from "../layouts/CompanionLayout";

function CompanionView() {
  const route = useRoute<RouteProp<RootStackParamList, "Home">>();
  const navigation = useNavigation<NavigationProp<RootStackParamList>>();
  const { chatId: routeChatId } = route.params || {};

  const { data: routeChatData, loading: routeChatLoading } = useGetCompanionChatByIdQuery({
    skip: !routeChatId,
    variables: {
      id: routeChatId!,
    },
    fetchPolicy: "network-only",
  });

  const routeChatExists =
    routeChatId &&
    !routeChatLoading &&
    routeChatData?.getCompanionChatById !== null &&
    routeChatData?.getCompanionChatById !== undefined;
  const shouldUseRouteChat = !!routeChatExists;

  const chatId = shouldUseRouteChat ? routeChatId! : null;

  const handleChatIdChange = useCallback(
    (newChatId: string) => {
      navigation.setParams({ chatId: newChatId });
    },
    [navigation]
  );

  const isLoadingChatId = routeChatId && routeChatLoading;

  return (
    <CompanionLayout>
      <ChatWindowContainer chatId={chatId} onChatIdChange={handleChatIdChange} isLoadingChatId={isLoadingChatId} />
    </CompanionLayout>
  );
}

export default CompanionView;
